import React from 'react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { __ } from '@wordpress/i18n';

// components
import ScopeBar from '../ScopeBar';
import CommentCard from '../CommentCard';
import CommentToolbar from '../CommentToolbar';

// store
import { useCommCenter } from '../../context';

const CommunicationsPanel = () => {
    const { visibleComments, activityScope, loading, searching, error } = useCommCenter();

    const renderFeed = () => {
        if (loading || searching) {
            return <p className="commCenter__empty">{__('Carico i commenti…', 'soundbetween')}</p>;
        }

        if (error) {
            return (
                <p className="commCenter__empty">
                    {__('Non è stato possibile caricare i commenti.', 'soundbetween')}
                </p>
            );
        }

        if (!visibleComments.length) {
            return (
                <p className="commCenter__empty">
                    {activityScope
                        ? __('Nessun commento per la selezione.', 'soundbetween')
                        : __('Nessun commento trovato.', 'soundbetween')}
                </p>
            );
        }

        return (
            <ul className="commentList">
                {visibleComments.map(comment => (
                    <li key={comment.id}>
                        <CommentCard comment={comment}/>
                    </li>
                ))}
            </ul>
        );
    }

    return (
        <div className="commPanel commPanel--comments">
            <ScopeBar subject="comments"/>
            <CommentToolbar/>
            <OverlayScrollbarsComponent
                element="div"
                className="commPanel__scroll"
                options={{ scrollbars: { autoHide: 'never' } }}
                defer>
                {renderFeed()}
            </OverlayScrollbarsComponent>
        </div>
    )
}

export default CommunicationsPanel;
